// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","button--disabled":"Button_button--disabled__DSoG2"};